import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LocalizedStrings from '../Localization';


class ContactNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.strings = LocalizedStrings({
            en: {
                first: "First Name",
                last: "Last Name",
                email: "E-mail",
                phone: "Phone",
                role: "Role",
                user: "user",
                partner: "partner",
                admin: "admin",
                partnerLabel: "Partner",
                notifications: "Notifications",
                unsubscribed: "Unsubscribed",
                subscribed: "Subscribed",
                extremePrices: "Extreme prices",
                cognitoStatus: "Cognito status",
                note: "NOTE",
                roleNote: "To manage user roles go to",
                manageUsers: "Manage Users",
                or: "or",
                managePartners: "Manage Partners",
                page: "page.",
                emailNote: "The user's email address can't be changed. In case you need to change it please add a new user.",

            },
            nl: {
                first: "Voornaam",
                last: "Achternaam",
                email: "E-mail",
                phone: "Telefoon",
                role: "Role",
                user: "gebruiker",
                partner: "partner",
                admin: "beheerder",
                partnerLabel: "Partner",
                notifications: "Meldingen",
                unsubscribed: "Afgemeld",
                subscribed: "Geabonneerd",
                extremePrices: "Extreme prijzen",
                cognitoStatus: "Cognito status",
                note: "NOTITIE",
                roleNote: "Ga naar om gebruikersrollen te beheren",
                manageUsers: "Gebruikers beheren",
                or: "of",
                managePartners: "Beheer partners",
                page: "bladzijde.",
                emailNote: "Het e-mailadres van de gebruiker kan niet worden gewijzigd. Voeg een nieuwe gebruiker toe als u deze moet wijzigen."
            }
        }, this.props.lang);
    }

    render() {

        let form_items = []
        if (this.props.fullForm && this.props.manageUsers)
            form_items = [
                { label: this.strings.first, name: 'firstName', required: true },
                { label: this.strings.last, name: 'lastName', required: true },
                { label: this.strings.email, name: 'email', required: this.props.readOnlyEmail ? false : true, disabled: this.props.readOnlyEmail, email: 'yes' },
                { label: this.strings.phone, name: 'phone', required: false },
                { label: this.strings.notifications, name: 'notifications', required: true },
                { label: this.strings.role, name: 'role', required: false, },
                { label: this.strings.partnerLabel, name: 'partner_id', required: false }
            ]
        else if (this.props.fullForm)
            form_items = [
                { label: this.strings.first, name: 'firstName', required: true },
                { label: this.strings.last, name: 'lastName', required: true },
                { label: this.strings.email, name: 'email', required: this.props.readOnlyEmail ? false : true, disabled: this.props.readOnlyEmail, email: 'yes' },
                { label: this.strings.phone, name: 'phone', required: false },
                { label: this.strings.notifications, name: 'notifications', required: true },
                { label: this.strings.role, name: 'role', required: false, disabled: true },
                { label: this.strings.partnerLabel, name: 'partner_id', required: false, disabled: true }
            ]
        else form_items = [
            { label: this.strings.first, name: 'firstName', required: true },
            { label: this.strings.last, name: 'lastName', required: true },
            { label: this.strings.email, name: 'email', required: this.props.readOnlyEmail ? false : true, disabled: this.props.readOnlyEmail, email: 'yes' },
            { label: this.strings.phone, name: 'phone', required: false },
            // { label: this.strings.role, name: 'role', required: false, disabled: true }
        ]

        return (
            <div>
                {
                    form_items.map(item => {

                        if (item.name === 'partner_id' && this.props.value.role !== 'partner')
                            return null

                        if (item.name === 'notifications')
                            return <div className={'form-group row'} key={item.name}>
                                <label htmlFor={item.name} className="col-sm-3 col-form-label">
                                    {item.label}
                                </label>
                                <div className="col-sm-9">
                                    <select className="form-control" id={item.name} name={item.name} required={true} value={this.props.value[item.name] || ''} onChange={this.props.onFieldChange}>
                                        <option value="0">{this.strings.unsubscribed}</option>
                                        <option value="1">{this.strings.subscribed}</option>
                                        <option value="2">{this.strings.extremePrices}</option>
                                    </select>
                                </div>
                            </div>

                        if (item.name === 'role' && this.props.manageUsers)
                            return <div className={'form-group row'} key={item.name}>
                                <label htmlFor={item.name} className="col-sm-3 col-form-label">
                                    {item.label}
                                </label>
                                <div className="col-sm-9">
                                    <select className="form-control" id={item.name} name={item.name} required={true} value={this.props.value[item.name] || ''} onChange={this.props.onFieldChange}>
                                        <option value={this.strings.user}>{this.strings.user}</option>
                                        <option value={this.strings.partner}>{this.strings.partner}</option>
                                        <option value={this.strings.admin}>{this.strings.admin}</option>
                                    </select>
                                </div>
                            </div>

                        return (
                            <div className={'form-group row ' + (item.required ? 'required' : '')} key={item.name}>
                                <label htmlFor={item.name} className="col-sm-3 col-form-label">
                                    {item.label}
                                </label>
                                <div className="col-sm-9">
                                    <input
                                        key={item.name}
                                        type="text"
                                        className="form-control"
                                        id={item.name}
                                        name={item.name}
                                        required={item.required}
                                        disabled={item.disabled}
                                        email={item.email}
                                        value={this.props.value[item.name] || ''}
                                        onChange={this.props.onFieldChange} />
                                    {
                                        item.name === 'email' && item.disabled ?
                                            <div className="form-text text-muted">
                                                <strong>{this.strings.note}: </strong>{this.strings.emailNote}
                                            </div>
                                            : item.name === 'role' && item.disabled ?
                                                <div className="form-text text-muted">
                                                    <strong>{this.strings.note}: </strong>{this.strings.roleNote} <em><Link to="/admin/manage-users">{this.strings.manageUsers}</Link></em> {this.strings.or} <em><Link to="/admin/manage-partners">{this.strings.managePartners} </Link></em> {this.strings.page}
                                                </div>
                                                : null
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export default ContactNew;
